import { HisItemParameter } from "../../his/behavior";
import { IHisInformationValue } from "../../his/HisInformationValue";
import { IItem, instanceOfIItem } from "./IItem";

/** HIS情報を設定可能項目のインターフェース */
export interface IHisInformationApplicable extends IItem {
  isEmpty: boolean;
  isHisInfo: boolean;
  hisItemParameter: HisItemParameter;
  groupName?: string; // グループ名の設定によるため必須ではない
  shouldInputFree: boolean;
  setHisInfoItems(hisInfoValue: IHisInformationValue, shouldSkipInputMethodKindUpdate: boolean): void;
  rollbackValue(): void;
  adjustFontSize(): void;
  adjustObjectHeight(): void;
  setSelectedItems(items: any[]): void;
}

export function instanceOfIHisInformationApplicable(instance: any): instance is IHisInformationApplicable {
  return (instance != null)
    && (instance.isHisInfo !== undefined)
    && (instance.hisItemParameter !== undefined)
    && (instance.shouldInputFree !== undefined)
    && (instance.setHisInfoItems !== undefined)
    && (instance.rollbackValue !== undefined)
    && (instance.adjustObjectHeight !== undefined)
    && (instance.setSelectedItems !== undefined)
    && instanceOfIItem(instance);
}
